import applyedFilters from "../../utils/applyedFilters";
import header from "../../utils/header.js";

const PDFManager = require("@/utils/PDFManager").default;
const PAYMENT = require("@/utils/payment").default;
export default async function ({
  party,
  filter,
  reportData,
  ticketBlocksMap,
}) {
  const document = new PDFManager({
    orientation: "landscape",
    format: "a4",
    margin: 5,
    initialY: 10,
  });

  await header(document, party, `Resumo de vendas`);

  applyedFilters(document, filter, {
    ticketBlocksMap,
  });
  const reducedPayments = reportData.reduce((acc, payment) => {
    payment.Ticket.forEach((ticket) => {
      const { TicketGroup, ...ticketBlock } = ticket.TicketBlock;
      const ticketGroup = TicketGroup;
      const payment = ticket.Payment;

      if (!acc.ticketGroups[ticketGroup.id]) {
        acc.ticketGroups[ticketGroup.id] = {
          ...ticketGroup,
          quantity: 0,
          courtesy: 0,
          amount: 0,
          ticketBlocks: {},
        };
      }

      if (!acc.ticketGroups[ticketGroup.id].ticketBlocks[ticketBlock.id]) {
        acc.ticketGroups[ticketGroup.id].ticketBlocks[ticketBlock.id] = {
          ...ticketBlock,
          price: ticketBlock.price,
          tamount: ticketBlock.amount,
          quantity: 0,
          courtesy: 0,
          amount: 0,
        };
      }

      // sum ticket group
      acc.ticketGroups[ticketGroup.id].quantity += 1;
      acc.ticketGroups[ticketGroup.id].amount += ticket.amount - ticket.platformFee;

      // sum ticket block
      acc.ticketGroups[ticketGroup.id].ticketBlocks[ticketBlock.id].amount +=
        ticket.amount - ticket.platformFee;
      acc.ticketGroups[ticketGroup.id].ticketBlocks[ticketBlock.id].quantity += 1;

      const isCourtesy = payment.paymentType === "COURTESY";
      if (isCourtesy) {
        acc.ticketGroups[ticketGroup.id].courtesy++;
        acc.ticketGroups[ticketGroup.id].ticketBlocks[ticketBlock.id].courtesy++;
      }
    });

    const channel = payment.paymentMethod === "POS" ? "POS" : "ONLINE";

    if (!acc.channels[channel]) {
      acc.channels[channel] = {
        name: channel,
        quantity: 0,
        amount: 0,
        tickets: 0,
        paymentTypes: {},
      };
    }

    if (!acc.channels[channel].paymentTypes[payment.paymentType]) {
      acc.channels[channel].paymentTypes[payment.paymentType] = {
        name: payment.paymentType,
        quantity: 0,
        amount: 0,
        tickets: 0,
      };
    }

    acc.channels[channel].quantity += 1;
    acc.channels[channel].paymentTypes[payment.paymentType].quantity += 1;

    payment.Ticket.forEach((ticket) => {
      acc.channels[channel].amount += ticket.amount - ticket.platformFee;
      acc.channels[channel].tickets += 1;

      acc.channels[channel].paymentTypes[payment.paymentType].amount += ticket.amount - ticket.platformFee;
      acc.channels[channel].paymentTypes[payment.paymentType].tickets += 1;
    });

    return acc;
  }, {
    ticketGroups: {},
    channels: {},
  });

  for (const ticketGroup of Object.values(reducedPayments.ticketGroups)) {
    // add title for pdv
    document.addTitle(`${ticketGroup.name}`, 13, { spacing: 1 });

    const paymentTypesHeaders = [
      "Lote",
      { content: "Preço", styles: { halign: "center" } },
      { content: "Ingressos Vendidos", styles: { halign: "center" } },
      { content: "Cortesias", styles: { halign: "center" } },
      { content: "Ingressos Emitidos", styles: { halign: "center" } },
      { content: "Valor Líquido", styles: { halign: "right" } },
    ];
    const paymentTypesData = Object.entries(ticketGroup.ticketBlocks).map(
      ([id, { name, quantity, courtesy, amount }]) => [
        name,
        { content: formatCurrency(ticketBlocksMap.get(id)?.price), styles: { halign: "center" } },
        { content: formatInt(quantity - courtesy), styles: { halign: "center" } },
        { content: formatInt(courtesy), styles: { halign: "center" } },
        { content: formatInt(quantity), styles: { halign: "center" } },
        { content: formatCurrency(amount), styles: { halign: "right" } },
      ]
    );

    // add footer
    paymentTypesData.push([
      "",
      {
        content: "Total",
        styles: { halign: "right", fontStyle: "bold", fontSize: 11 },
      },
      {
        content: formatInt(ticketGroup.quantity - ticketGroup.courtesy),
        styles: { halign: "center", fontStyle: "bold", fontSize: 11 },
      },
      {
        content: formatInt(ticketGroup.courtesy),
        styles: { halign: "center", fontStyle: "bold", fontSize: 11 },
      },
      {
        content: formatInt(ticketGroup.quantity),
        styles: { halign: "center", fontStyle: "bold", fontSize: 11 },
      },
      {
        content: formatCurrency(ticketGroup.amount),
        styles: { halign: "right", fontStyle: "bold", fontSize: 11 },
      },
    ]);
    document.addTable(paymentTypesHeaders, paymentTypesData, { spacing: 1 });
    document.addSpace(5);
  }
  document.addDivider();
  document.addSpace(3);

  // add payment types
  const paymentTypesHeaders = [
    "Tipo de Pagamento",
    { content: "Operações", styles: { halign: "center" } },
    { content: "Ingressos", styles: { halign: "center" } },
    { content: "Valor", styles: { halign: "right" } },
  ];

  for (const channel of Object.values(reducedPayments.channels)) {
    document.addTitle(`${channel.name}`, 13, { spacing: 1 });
    const paymentTypesData = Object.entries(channel.paymentTypes).map(
      ([paymentType, { name, quantity, amount, tickets }]) => [
        PAYMENT.paymentType[paymentType].text,
        { content: formatInt(quantity), styles: { halign: "center" } },
        { content: formatInt(tickets), styles: { halign: "center" } },
        { content: formatCurrency(amount), styles: { halign: "right" } },
      ]
    );
    paymentTypesData.push([
      {
        content: "Total",
        styles: { halign: "right", fontStyle: "bold", fontSize: 11 },
      },
      { content: formatInt(channel.quantity), styles: { halign: "center", fontStyle: "bold", fontSize: 11 } },
      { content: formatInt(channel.tickets), styles: { halign: "center", fontStyle: "bold", fontSize: 11 } },
      { content: formatCurrency(channel.amount), styles: { halign: "right", fontStyle: "bold", fontSize: 11 } },
    ]);
    document.addTable(paymentTypesHeaders, paymentTypesData, { spacing: 1 });
    document.addSpace(5);
  }

  return document;
}

const formatInt = (value) => {
  return new Intl.NumberFormat("pt-BR").format(value);
};

const formatCurrency = (value) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
};
